import type { OpinlyConfig } from "@opinly/shared";
import type { FullPost, PostList } from "@opinly/backend";

/** JSON-safe mirrors of the SDK types, so server-fn serialization validation passes. */
export type JsonValue = string | number | boolean | null | JsonValue[] | { [key: string]: JsonValue };
export type BlogPostData = Omit<FullPost, "content"> & { content: JsonValue };
export type BlogPostList = PostList;

/** Public site + blog configuration shared by server fetching and client rendering. */
export const SITE_URL = "https://www.casamipajobe.com";

/** Post images are served from the company CDN namespace. */
export const OPINLY_IMAGES_PREFIX = "https://cdn.opinly.ai/nl1APINYTJG7yE8WbBCdp";

export const opinlyConfig: OpinlyConfig = {
  imagesPrefix: OPINLY_IMAGES_PREFIX,
  siteUrl: SITE_URL,
  blogPrefix: "/blog",
  siteName: "Casa Mi Pajobe",
};

/** Class names for the default Opinly node renderers (no typography plugin in this app). */
export const opinlyClassNames = {
  paragraph: "mt-4 text-base leading-relaxed text-foreground/90",
  heading: "mt-10 font-semibold tracking-tight text-foreground",
  image: "my-8 w-full rounded-xl border border-border/60",
  bulletList: "mt-4 list-disc space-y-2 pl-6 text-foreground/90",
  orderedList: "mt-4 list-decimal space-y-2 pl-6 text-foreground/90",
  listItem: "leading-relaxed",
  blockquote: "my-6 border-l-4 border-primary/40 pl-4 italic text-muted-foreground",
  code: "rounded bg-muted px-1.5 py-0.5 font-mono text-[0.85em]",
  codeBlock: "my-6 overflow-x-auto rounded-xl bg-muted p-4 font-mono text-sm",
  horizontalRule: "my-10 border-border",
  table: "my-6 w-full border-collapse text-sm [&_td]:border [&_td]:border-border [&_td]:p-2 [&_th]:border [&_th]:border-border [&_th]:p-2",
  link: "text-primary underline underline-offset-2 hover:opacity-80",
};

export function formatPostDate(iso: string, locale = "en-GB"): string {
  try {
    return new Date(iso).toLocaleDateString(locale, {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}
